import ReactDOM from "react-dom/client";
import { Provider } from "./components/ui/provider";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Home from "./pages/home";
import Dashboard from "./pages/dashboard";
import { getAnalytics } from "firebase/analytics";
import { app } from "./firebase.js";

getAnalytics(app);

const root = document.getElementById("root");
const dom = ReactDOM.createRoot(root);

dom.render(
	<Provider>
		<BrowserRouter>
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/dashboard" element={<Dashboard />} />
				<Route path="*" element={<Navigate to={"/"} replace />} />
			</Routes>
		</BrowserRouter>
	</Provider>,
);
